import { render, staticRenderFns } from "./PrivacyV2.vue?vue&type=template&id=d445f91c&scoped=true&"
import script from "./PrivacyV2.vue?vue&type=script&lang=js&"
export * from "./PrivacyV2.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyV2.vue?vue&type=style&index=0&id=d445f91c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d445f91c",
  null
  
)

export default component.exports